import { render, staticRenderFns } from "./menu-icons.vue?vue&type=template&id=5c480393&"
import script from "./menu-icons.vue?vue&type=script&lang=js&"
export * from "./menu-icons.vue?vue&type=script&lang=js&"
import style0 from "./menu-icons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports